import { useNavigate } from '@melio/platform-utils';

import { useRouter } from '@/hooks/router.hooks';

export const useAddInstantBillRedirects = (returnUrl?: string) => {
  const navigate = useNavigate();
  const { goToPayDashboard, goToJustPaySchedulePayment } = useRouter();

  const onDone = (billId?: string) => {
    if (billId) {
      goToJustPaySchedulePayment({ billId, returnUrl });
    }
  };

  const onBack = () => {
    if (returnUrl) {
      return navigate(returnUrl);
    }
    goToPayDashboard();
  };

  const onClose = () => {
    if (returnUrl) {
      return navigate(returnUrl);
    }
    goToPayDashboard();
  };

  return { onDone, onBack, onClose };
};
